(() => {
if (window.moldeaComplementReady) return;
window.moldeaComplementReady = true;
let adding = false;
const rootUrl = () => window.Shopify?.routes?.root || '/';
document.addEventListener('change', e => {
  if (!e.target.matches('[data-complement-variant]')) return;
  const option = e.target.selectedOptions[0];
  const price = e.target.closest('article')?.querySelector('[data-complement-price]');
  if (price && option?.dataset.price) price.textContent = option.dataset.price;
});
document.addEventListener('submit', async e => {
  const form = e.target.closest('form[data-moldea-add]');
  if (!form) return;
  e.preventDefault();
  if (adding || !form.reportValidity()) return;
  const id = new FormData(form).get('id');
  if (!id) return;
  adding = true;
  const button = form.querySelector('button[type="submit"]');
  const status = form.querySelector('[role="status"]');
  const card = form.closest('[data-complement-product]');
  button.disabled = true;
  button.textContent = button.dataset.addingLabel;
  status.textContent = '';
  let committed = false;
  try {
    const drawer = document.querySelector('cart-drawer');
    const renderer = drawer?.renderContents ? drawer : document.querySelector('cart-notification');
    let sectionIds = renderer?.getSectionsToRender?.().map(s => s.id) || ['cart-drawer','cart-icon-bubble'];
    const cartItems = document.querySelector('cart-items');
    if (cartItems?.getSectionsToRender) sectionIds = [...sectionIds, ...cartItems.getSectionsToRender().map(s => s.section || s.id)];
    sectionIds = [...new Set(sectionIds)].slice(0,5);
    const response = await fetch(rootUrl() + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(id),quantity:1}],sections:sectionIds,sections_url:location.pathname + location.search})});
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || button.dataset.errorLabel);
    committed = true;
    status.textContent = button.dataset.addedLabel;
    document.dispatchEvent(new CustomEvent('moldea:complement-added',{detail:{productId:card.dataset.complementProduct,variantId:id,placement:card.closest('.moldea-cart-complements')?'cart':'product'}}));
    if (renderer?.renderContents && data.sections) {
      renderer.classList.remove('is-empty');
      renderer.renderContents(data);
    } else {
      location.assign(rootUrl() + 'cart');
      return;
    }
    if (cartItems?.getSectionsToRender && data.sections) {
      for (const section of cartItems.getSectionsToRender()) {
        const html = data.sections[section.section || section.id];
        const target = document.getElementById(section.id);
        if (!html || !target) continue;
        const parsed = new DOMParser().parseFromString(html,'text/html');
        const source = parsed.querySelector(section.selector);
        const dest = target.querySelector(section.selector) || target;
        if (source) dest.innerHTML = source.innerHTML;
      }
    }
    document.querySelectorAll('[data-moldea-crosssell] [data-complement-product]').forEach(x => {if(x.dataset.complementProduct === card.dataset.complementProduct)x.hidden = true;});
  } catch (error) {
    if (committed) {
      location.assign(rootUrl() + 'cart');
    } else {
      status.textContent = error.message || button.dataset.errorLabel;
    }
  } finally {
    adding = false;
    if (button.isConnected) {button.disabled=false;button.textContent='+ ' + button.dataset.addLabel;}
  }
});
function initCarousel(root) {
  if(root.dataset.crossReady) return;
  root.dataset.crossReady='1';
  const viewport=root.querySelector('.moldea-crosssell__viewport');
  if (!viewport || root.dataset.autoplay!=='true' || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let pausedUntil=0;
  const pause=()=>{pausedUntil=Date.now()+10000;};
  ['pointerdown','wheel','focusin','mouseenter'].forEach(event=>root.addEventListener(event,pause,{passive:true}));
  const timer=setInterval(()=>{
    if(!root.isConnected){clearInterval(timer);return;}
    if(document.hidden || Date.now()<pausedUntil || root.contains(document.activeElement) || root.matches(':hover'))return;
    const bounds=root.getBoundingClientRect();
    if(bounds.bottom<0 || bounds.top>innerHeight)return;
    const max=viewport.scrollWidth-viewport.clientWidth;
    if(max<=0)return;
    const step=viewport.querySelector('.moldea-crosssell__card:not([hidden])')?.getBoundingClientRect().width || 160;
    viewport.scrollTo({left:viewport.scrollLeft>=max-5?0:Math.min(max,viewport.scrollLeft+step+12),behavior:'smooth'});
  },Math.max(6000,Number(root.dataset.speed||35)*200));
}
function initCartRefresh() {
  const holder=document.querySelector('[data-moldea-cart-holder]');
  const items=document.querySelector('cart-items');
  if(!holder || !items || items.dataset.moldeaRefreshReady)return;
  items.dataset.moldeaRefreshReady='1';
  let timer, revision=0;
  new MutationObserver(()=>{
    clearTimeout(timer);
    timer=setTimeout(async()=>{
      const current=++revision;
      try {
        const url=new URL(location.href);
        url.searchParams.set('section_id',holder.dataset.sectionId);
        const response=await fetch(url.toString());
        if(!response.ok)return;
        const html=await response.text();
        if(current!==revision)return;
        const parsed=new DOMParser().parseFromString(html,'text/html');
        const fresh=parsed.querySelector('[data-moldea-cart-holder]');
        if(fresh)holder.innerHTML=fresh.innerHTML;
      } catch {}
    },250);
  }).observe(items,{childList:true,subtree:true});
}
function excludeRepeatedProducts(){
  const ids=new Set(Array.from(document.querySelectorAll('[data-moldea-crosssell] [data-complement-product]')).filter(x=>!x.hidden).map(x=>x.dataset.complementProduct));
  document.querySelectorAll('[data-related-product]').forEach(x=>{x.hidden=ids.has(x.dataset.relatedProduct);});
  document.querySelectorAll('.moldea-related').forEach(section=>{section.hidden=!section.querySelector('[data-related-product]:not([hidden])');});
}
const run=()=>{excludeRepeatedProducts();document.querySelectorAll('[data-moldea-crosssell]').forEach(initCarousel);initCartRefresh();};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
document.addEventListener('shopify:section:load',run);
})();